// Eager ESM imports: no first-frame dependency on asynchronous shader registration.
import {ShaderStore} from '@babylonjs/core/Engines/shaderStore.js';
import {defaultVertexShader} from '@babylonjs/core/Shaders/default.vertex.js';
import {defaultPixelShader} from '@babylonjs/core/Shaders/default.fragment.js';
import {pbrVertexShader} from '@babylonjs/core/Shaders/pbr.vertex.js';
import {pbrPixelShader} from '@babylonjs/core/Shaders/pbr.fragment.js';
import {colorVertexShader} from '@babylonjs/core/Shaders/color.vertex.js';
import {colorPixelShader} from '@babylonjs/core/Shaders/color.fragment.js';
import {shadowMapVertexShader} from '@babylonjs/core/Shaders/shadowMap.vertex.js';
import {shadowMapPixelShader} from '@babylonjs/core/Shaders/shadowMap.fragment.js';
import {outlineVertexShader} from '@babylonjs/core/Shaders/outline.vertex.js';
import {outlinePixelShader} from '@babylonjs/core/Shaders/outline.fragment.js';
const required=[defaultVertexShader,defaultPixelShader,pbrVertexShader,pbrPixelShader,colorVertexShader,colorPixelShader,shadowMapVertexShader,shadowMapPixelShader,outlineVertexShader,outlinePixelShader];
export function initializeShaders(){
 for(const {name,shader}of required){
  if(!shader.includes('void main')||/<!doctype|<html|<head|<body/i.test(shader))throw new Error('Invalid GLSL module: '+name);
  ShaderStore.ShadersStore[name]=shader;
 }
 // Shader modules import their own include graph. Validate the canonical store too.
 for(const [name,source]of Object.entries(ShaderStore.IncludesShadersStore))
  if(/<!doctype|<html|<head|<body/i.test(source))throw new Error('Invalid GLSL include: '+name);
 return required.map(s=>s.name);
}
